"use client";
import Head from "next/head";
import { useEffect, useState } from "react";

export default function DynamicSEO({ title, description }) {
  const [pageTitle, setPageTitle] = useState(title);
  const [pageDescription, setPageDescription] = useState(description);

  useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  return (
    <Head>
      <meta name="description" content={pageDescription} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content="/og-image.jpg" />
      <link rel="icon" href="/logoFav.ico" />
    </Head>
  );
}
